import { NoResultsIcon } from 'assets';
import * as S from './styled';

const NoMessagesBlock = ({ title, subTitle }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <S.NoMessagesBlock>
        <S.NoMessagesBlockMain>
          <NoResultsIcon style={{ marginBottom: '24px' }} />
          <S.NoMessagesBlockMainTitle>{title}</S.NoMessagesBlockMainTitle>
          <S.NoMessagesBlockMainSubTitle style={{ marginBottom: '0px' }}>
            {subTitle}
          </S.NoMessagesBlockMainSubTitle>
        </S.NoMessagesBlockMain>
      </S.NoMessagesBlock>
    </div>
  );
};

export default NoMessagesBlock;
